<div class="rounded-xl overflow-hidden shadow-lg">

    <!-- Header -->
    <div class="flex items-center justify-center dialog-header">
        Delete Academic Year
        <div class="absolute right-4">
            <button (click)="onCancel()" class="text-white hover:text-gray-300">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content">
        <div class="flex items-center mb-4">
            <i class="pi pi-exclamation-triangle text-orange-500 text-2xl mr-3"></i>
            <span class="text-lg">Are you sure you want to delete this roll number configuration?</span>
        </div>

        <div class="bg-gray-50 p-4 rounded-lg">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <strong>Department:</strong>
                    <p class="text-gray-700">{{ rollNumberConfigData?.department?.name || 'N/A' }}</p>
                </div>
                <div>
                    <strong>Academic Year:</strong>
                    <p class="text-gray-700">{{ rollNumberConfigData?.academic_year?.year_name || 'N/A' }}</p>
                </div>
                <div>
                    <strong>Prefix:</strong>
                    <p class="text-gray-700">{{ rollNumberConfigData?.prefix || 'N/A' }}</p>
                </div>
                <div>
                    <strong>Counter:</strong>
                    <p class="text-gray-700">{{ rollNumberConfigData?.counter || 'N/A' }}</p>
                </div>
                <div>
                    <strong>Length:</strong>
                    <p class="text-gray-700">{{ rollNumberConfigData?.length || 'N/A' }} digits</p>
                </div>
            </div>
        </div>

        <div class="mt-4 p-3 bg-yellow-50 border-l-4 border-yellow-400">
            <p class="text-yellow-800 text-sm">
                <strong>Warning:</strong> This action cannot be undone. Deleting this configuration may affect roll
                number generation for the associated department and academic year.
            </p>
        </div>

        <div class="dialog-footer flex justify-end gap-2 mt-6">
            <p-button type="button" label="Cancel" severity="secondary" [outlined]="true" (onClick)="onCancel()"
                [disabled]="btnLoading">
            </p-button>

            <p-button type="button" label="Delete" severity="danger" [loading]="btnLoading" (onClick)="onDelete()">
            </p-button>
        </div>
    </div>



</div>